export default __webpack_public_path__ + "images/94341c7f7b23c3b6df168cafa73b7be0-phoenix_desktop.webp";